import React, {Component} from 'react';
import styled from 'styled-components';

import Card from '../../components/Card';
import Icon from '../../components/Icon';
import Button from '../../components/Button';
import ConfirmDialog from '../../components/ConfirmDialog';

class DeletableCard extends Component {
  static defaultProps = {
    onBeforeOk: () => true
  };

  state = {
    confirm: false
  };

  handleOpenConfirm = () => {
    const {onBeforeOk} = this.props;

    if (onBeforeOk()) {
      this.setState({confirm: true});
    }
  }

  handleCloseConfirm = () => {
    this.setState({confirm: false});
  }
  
  render() {
    const {dialogTitle, dialogDescription, ok, cancel, onOk, children, overlay, onBeforeOk, disabled, ...cardProps} = this.props;
    const {confirm} = this.state;

    return (
      <Card
        overlay={overlay || (confirm && (
          <ConfirmDialog
            title={dialogTitle}
            description={dialogDescription}
            ok={ok}
            cancel={cancel}
            onOk={onOk}
            onCancel={this.handleCloseConfirm}
          />
        ))}
        {...cardProps}>
        <Container focusable={cardProps.focusable}>
          <Body>{children}</Body>
          <ButtonContainer>
            <Button
              tertiary
              disabled={disabled}
              onClick={this.handleOpenConfirm}>
              <Icon name="trash-2" />
            </Button>
          </ButtonContainer>
        </Container>
      </Card>
    );
  }
}

const Container = styled.div`
  display: flex;
  width: 100%;
  padding: 1.875rem;

  @media (max-width: 75rem) {
    padding: 1.25rem;
  }

  ${props => {
    if (props.focusable) {
      return `
        :focus-within {
          padding: 1.75rem;

          @media (max-width: 75rem) {
            padding: 1.125rem;
          }
        }
      `;
    }
  }}
`;

const Body = styled.div`
  width: calc(100% - 3.625rem);
`;

const ButtonContainer = styled.div`
  margin-left: 1rem;
`;

export default DeletableCard;